import './style.css'
import Experience from './Experiance/Experiance'
const myExperance= new Experience(document.querySelector('canvas.webgl'))
